var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-panel has-text-centered"},[_c('TextFileSelector',{on:{"fileSelected":_vm.fileSelected}}),_c('ZipFileSelector',{on:{"fileSelected":_vm.fileSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }